"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WofPrizeTypes = void 0;
var WofPrizeTypes;
(function (WofPrizeTypes) {
    WofPrizeTypes["Campaign"] = "campaign";
    WofPrizeTypes["Promo"] = "promo";
    WofPrizeTypes["Ticket"] = "ticket";
    WofPrizeTypes["Cashback"] = "cashback";
})(WofPrizeTypes = exports.WofPrizeTypes || (exports.WofPrizeTypes = {}));
